var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpander(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Button",
    rx: 7.5,
    width: 27,
    height: 27,
    transform: "translate(0.500000 0.500000)",
    fill: "#2D303E",
    fillOpacity: 1,
    stroke: "#718EBF",
    strokeOpacity: 1,
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4348_14278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M11.8 10.19C12.06 10.45 12.06 10.87 11.8 11.13L8.94 14L11.8 16.86C12.06 17.12 12.06 17.54 11.8 17.8C11.54 18.06 11.12 18.06 10.86 17.8L7.52 14.47C7.26 14.21 7.26 13.78 7.52 13.52L10.86 10.19C11.12 9.93 11.54 9.93 11.8 10.19ZM16.19 10.19C16.45 9.93 16.87 9.93 17.13 10.19L20.47 13.52C20.73 13.78 20.73 14.21 20.47 14.47L17.13 17.8C16.87 18.06 16.45 18.06 16.19 17.8C15.93 17.54 15.93 17.12 16.19 16.86L19.05 14L16.19 11.13C15.93 10.87 15.93 10.45 16.19 10.19Z",
    fill: "#718EBF",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpander);
export default __webpack_public_path__ + "static/media/expander.4469d31daf1c77b446d1b4b8f4bd117d.svg";
export { ForwardRef as ReactComponent };